{
  "$id": "wealthlane://forms/department/rules",
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [],
  "observers": [],
  "rules": []
}
